import { FuelButton, FuelIcon, FuelTextField } from '@frete.com/fuel-react';
import { useTextFieldSearchTrucker } from 'hooks/openSearchTrucker/useTextField';
import React, { useRef } from 'react';
import { useDeviceSize } from 'hooks/useDeviceSize';
import { handleActiveFocus } from 'utils/handleActiveFocus';
import * as S from './styled';

const InputSearchTrucker = () => {
  const inputRef = useRef(null);
  const {
    propsTextField: { states, events },
  } = useTextFieldSearchTrucker();
  const { isDesktop } = useDeviceSize();

  return (
    <>
      {isDesktop && (
        <S.ButtonWrapper>
          <FuelButton
            trailingIcon="search"
            trailingIconStyle="filled"
            variant="secondary"
            onClick={() => {
              events.onFocus();
              handleActiveFocus(inputRef);
            }}
          >
            Pré-consulta
          </FuelButton>
        </S.ButtonWrapper>
      )}
      <S.WrapperInputSearch isTextFieldFocus={states.isTextFieldFocus} data-testid="open-search-input">
        <FuelTextField
          ref={inputRef}
          customIcon={false}
          placeholder={states.placeholder}
          inputmode="numeric"
          type="text"
          value={states.valueInput}
          hasSuffix
          onKeyUp={(e) => events.onKeyUp(e)}
          onKeyPress={(e) => events.onKeyPress(e)}
          onFocus={() => events.onFocus()}
          onPaste={(e) => events.onPaste(e)}
          state={states.hasError ? 'error' : 'default'}
        >
          <FuelIcon name="search" iconStyle="outlined" slot="suffix" size="small" />
        </FuelTextField>
        {states.hasError && <S.ErrorMessage hasError={states.hasError}>{states.errorMessage}</S.ErrorMessage>}
      </S.WrapperInputSearch>
    </>
  );
};

export default InputSearchTrucker;
